/**
 * Browser-specific String prototype extensions
 *
 * Platform-agnostic extensions are imported from switch-core.
 * This file adds web-specific functionality.
 */

// Import platform-agnostic extensions from switch-core
import "../../core_bridge/switch-core/extensions/string";

declare global {
  interface String {
    // Browser/Web-specific extensions
    toBlob(mimeString: string): Blob;
    dateZuluToHuman(): string;
    convertToRemoteStickerUrl(): string;
    relativePathToFullPath(): string;
    relativePathToFullPathRaw(): string;
  }
}

// Browser-specific: Uses date-fns for formatting
import { format } from "date-fns";

String.prototype.dateZuluToHuman = function dateZuluToHuman(this: string): string {
  const dateFromTimestamp = new Date(this);
  return format(dateFromTimestamp, "d - HH:mm");
};

// Browser-specific: Uses Blob constructor
String.prototype.toBlob = function toBlob(this: string, mimeString: string): Blob {
  const byteString = atob(this);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([int8Array], { type: mimeString });
  return blob;
};

// Web-specific: Sticker URL conversion
// Note: Uses a hardcoded sticker store URL. Update if needed.
const STICKER_STORE_URL = "https://switch168-sticker-store-system.sfo3.digitaloceanspaces.com";

String.prototype.convertToRemoteStickerUrl = function convertToRemoteStickerUrl(this: string): string {
  // Web format: https://switch168-sticker-store-system.sfo3.digitaloceanspaces.com/coco/coco_punch.png
  const endString = this.split(".com/")[1];
  if (!endString) return this; // Return original if format doesn't match
  return `${STICKER_STORE_URL}/${endString}`;
};

// Web-only: paths are already relative in IndexedDB/localStorage
String.prototype.relativePathToFullPath = function relativePathToFullPath(this: string): string {
  return this;
};

String.prototype.relativePathToFullPathRaw = function relativePathToFullPathRaw(this: string): string {
  return this;
};

console.log("[extensions/string] browser extensions loaded");
